export const confirmDialogInitialProps = {
  isVisible: false,
  title: '',
  message: '',
  handleConfirm: () => {},
  handleReject: () => {},
};
